import {
  AutomationActionAsanaCreateTaskDenormalized,
  IAutomationActionTemplateAsanaCreateTask
} from '@dadohr/shared/domainTypes/experience';
import { useUnsafeTranslation } from '../../../../../../../i18next';
import {
  escapeReplacements,
  LightMdToJsx
} from '../../../../../../../services/formatter';
import { MinimalTaskBuilderContext } from '../../../TaskBuilder/types';
import { ActionDefinition } from '../../types';
import {
  ActionSummaryBody,
  ActionSummaryContainer,
  ActionSummaryHeading
} from '../shared';

export const ActionSummaryAsanaCreateTask = ({
  a,
  expTpl,
  def
}: {
  a:
    | IAutomationActionTemplateAsanaCreateTask
    | AutomationActionAsanaCreateTaskDenormalized;
  expTpl: MinimalTaskBuilderContext;
  def: ActionDefinition;
}) => {
  const { t } = useUnsafeTranslation();
  return (
    <ActionSummaryContainer>
      <ActionSummaryHeading def={def} />
      <ActionSummaryBody>
        <LightMdToJsx>
          {t(
            'Create a task in the workspace **{{ workspace }}** in the project **{{ project }}** with the name **{{ taskName }}**.',
            {
              workspace: a.workspace.name || '...',
              project: a.project.name || '...',
              taskName: escapeReplacements(a.title) || '...'
            }
          )}
        </LightMdToJsx>
      </ActionSummaryBody>
    </ActionSummaryContainer>
  );
};
